import type { ReactNode } from "react";

const GalleryTitle = ({ children }: { children: ReactNode }) => (
	<em className="mt-[0.5em] block text-center text-[0.875em] font-light leading-[1.4em] text-[color:var(--color-image-title)]">
		{children}
	</em>
);

export default GalleryTitle;
